import { type IApiGeoGetRoadsResponse } from '@/repositories/generated/shared/monolith-cian-realty/api/geo/get-roads';

import { type IHighway, type IHighwayDirection } from '@/microfrontends/filters/shared/types/highways';

export function prepareHighwayDirectionss(response: IApiGeoGetRoadsResponse): IHighwayDirection[] {
  return response.reduce((acc, item) => {
    if (!item.name) {
      return acc;
    }

    const highways = (item.highways || []).filter(
      (highway): highway is IHighway => !!(highway.fullName && highway.id && highway.name),
    );

    acc.push({
      name: item.name,
      highways,
    });

    return acc;
  }, [] as IHighwayDirection[]);
}
